import clsx from "clsx";

import classes from "../../styles.module.scss";

import type { ITableContainerProps } from "@components/organisms/pageTable";

export function TableContainer({ children }: ITableContainerProps) {
  return <div className={clsx(classes.pageTable__container)}>{children}</div>;
}
